













































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import addTaskMixin from './addTaskMixin'
import BillApi from '@/api/bill2'

@Component({})
export default class Analysis extends Mixins(addTaskMixin) {
	private beforeFileUpload(e: any, list: any) {
		return this.beforeUpload(e, list, 5)
	}

	public onTaskAdd() {
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				if (!this.fileList.length) {
					return this.$message.error('请上传票据文件')
				}
				values.invoiceFileId = this.fileId
				values.invoiceFileName = this.picName

				this.addLoading = true
				BillApi.parseInvoice(values)
					.then((res: any) => {
						this.orderId = res.data
						this.pollingAdd(
							{ orderId: this.orderId },
							() => {
								this.onFailOk()
							},
							() => {
								this.onOk()
							}
						)
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}
}
